import convertBase64LengthToKb from '@/helpers/convertBase64LengthToKb';

// TODO: After reorganize the Vue18n plugin, put it in a separate file and remove the "vm" argument

/**
 * A method for determining whether value validation is mandatory
 * @param {required} @type {boolean} - field required
 * @param {triger} @type {string} - 'blur' 'change' ...
 * @param {vm} @type {object} - context required for v18n, because implementation differs from other projects
 * @return {array[validator]} - returns an array of validation rules for the ElForm component
 */
export function simpleRequiredValidationRule(required, trigger, vm) {
  return {
    required,
    message: vm.$i18n.t('common__validation__is_required'),
    trigger,
  };
}

/**
 * Method for generating validation rules for fields of type file
 * @param {triger} @type {string} - 'blur' 'change' ...
 * @param {maxSize} @type {string|number} - maximum file weight in kilobytes
 * @param {required} @type {boolean} - field required
 * @param {vm} @type {object} - context required for v18n, because implementation differs from other projects
 * @return {array[validator]} - returns an array of validation rules for the ElForm component
 */

export function fileValidationRule(trigger, maxSize, required, vm) {
  const validationRule = [
    {
      validator(rule, value, callback) {
        if (!value && !required) {
          callback();
        } else if (!value && required) {
          callback(new Error(vm.$i18n.t('common__validation__is_required')));
        } else if (convertBase64LengthToKb(value.length) > parseFloat(maxSize)) {
          const getFileSizeText = size => {
            if (size < 1000) {
              return vm.$i18n.t('common__files_size_kb', { size });
            } else {
              return vm.$i18n.t('common__files_size_mb', { size: (size / 1000).toFixed(1) });
            }
          };

          callback(
            new Error(
              vm.$i18n.t('common__validation__invalid_file_size', {
                size: getFileSizeText(maxSize),
              })
            )
          );
        } else {
          callback();
        }
      },
      trigger,
    },
  ];

  if (required) {
    validationRule.push({
      required: true,
      message: vm.$i18n.t('common__validation__is_required'),
      trigger,
    });

    return validationRule;
  }
}

/**
 * A method for generating validation rules for text fields
 * @param {triger} @type {string} - 'blur' 'change' ...
 * @param {regeExp} @type {string| RegExp} - the regular expression on which the test will be performed
 * @param {required} @type {boolean} - field required
 * @param {vm} @type {object} - context required for v18n, because implementation differs from other projects
 * @return {array[validator]} - returns an array of validation rules for the ElForm component
 */

export function regexpTextValidationRule(trigger, regExp, required, vm) {
  const validationRule = [
    {
      validator(rule, value, callback) {
        const regExpArr = Array.isArray(regExp) ? regExp : [regExp];

        if (!value && !required) {
          callback();
        } else if (!value && required) {
          callback(new Error(vm.$i18n.t('common__validation__is_required')));
        } else if (!regExpArr.map(item => new RegExp(item.expression).test(value)).some((item)=> item)) {
          callback(new Error(vm.$i18n.t('common__validation__invalid_format')));
        } else {
          callback();
        }
      },
      trigger,
    },
  ];

  if (required) {
    validationRule.push({
      required: true,
      message: vm.$i18n.t('common__validation__is_required'),
      trigger,
    });
  }

  return validationRule;
}
